import { ShareholderDocumentsToGetAll } from 'model/shareholder-documents.model';
import { BaseStoreState } from 'reducer/baseStoreState';
import { Page } from 'services/page';

export enum GetShareholderDocumentsActionTypes {
    GET_SHAREHOLDER_DOCUMENTS_REQUEST = '@@shareholder/GET_SHAREHOLDER_DOCUMENTS_REQUEST',
    GET_SHAREHOLDER_DOCUMENTS_SUCCESS = '@@shareholder/GET_SHAREHOLDER_DOCUMENTS_SUCCESS',
    GET_SHAREHOLDER_DOCUMENTS_ERROR = '@@shareholder/GET_SHAREHOLDER_DOCUMENTS_ERROR',
    GET_SHAREHOLDER_DOCUMENTS_RESET_STATE = '@@shareholder/GET_SHAREHOLDER_DOCUMENTS_RESET_STATE'
}

export interface GetShareholderDocumentsState extends BaseStoreState {
    readonly shareholderDocuments?: Page<ShareholderDocumentsToGetAll>;
}
